import { useCallback } from 'react'
import { CellEditingStoppedEvent } from 'ag-grid-community'

export const useRefreshDataPointsCell = <T>() =>
  useCallback((event: CellEditingStoppedEvent<T>) => {
    if (!event.node) {
      return
    }

    event.api?.refreshCells({
      rowNodes: [event.node],
      columns: ['dataPoints'],
      force: true,
    })
  }, [])
